import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import getCsrfToken from '@/store/Csrf'
import {commonUtil} from '@/util'

import requestOrderRegister from './request/requestOrderRegister'
import requestOrderCompleteRegister from './request/requestOrderCompleteRegister'
import requestOrdersCompleteRegister from './request/requestOrdersCompleteRegister'
import requestOrderPaymentRegister from './request/requestOrderPaymentRegister'
import requestOrdersPaymentRegister from './request/requestOrdersPaymentRegister'
import requestOrderEdit from './request/requestOrderEdit'
import orderReason from '@/config/order/orderReason'
import {dateFormatYYYYMMDD} from '@/mixins/format'

const Actions = {
    // OR02 発注登録
    registerOrder: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrderRegister.request.createRequest(params)

        const ret = await axios
            // .get(apiMock.ORDER_REGISTER_EDIT, params)
            .post(api.ORDER_REGISTER_EDIT, req)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)

                return false
            })
        return ret
    },
    // OH01 発注履歴一覧取得
    getOrderListFromApi: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        const ret = await axios
            // .get(apiMock.ORDER_LIST, params)
            .get(api.ORDER_LIST, {params: params})
            .then((response) => {
                const path = mutationsTypes.ORDER_SET_ORDER_LIST
                commit(path, response.data)
                commonUtil.hasRegisteredUserInfo(response.data)

                // ページャーをセット
                const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
                const pageCount = commonUtil.getPageCount(
                    response.data.meta.totalRows,
                    response.data.meta.perPage
                )
                commit(
                    `UI/${pagePath}`,
                    {length: pageCount, key: 'orderHistory'},
                    {root: true}
                )

                const getData = getters.getOrderListFromState
                const ret = commonUtil.afterApiSuccessProcess(response, getData)
                return ret
            })
            .catch((error) => {
                // uiControll.commonErrorControl(error.response)
                commonUtil.afterApiFailProcess(error.response)

                return false
            })
        return ret
    },
    // OH04 発注完成
    registerOrderComplete: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrderCompleteRegister.request.createRequest(params)
        const ret = await axios
            // .get(apiMock.ORDER_COMPLETE)
            .patch(`${api.ORDER_COMPLETE}/${params.id}`, req)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH08 出金履歴取得
    getOrderPaymentListFromApi: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        const ret = await axios
            // .get(apiMock.ORDER_PAYMENT_LIST)
            .get(`${api.ORDER_PAYMENT_LIST}/${params.id}`)
            .then((response) => {
                const path = mutationsTypes.ORDER_SET_ORDER_PAYMENT_LIST
                commit(path, response.data.data)
                const getData = getters.getOrderPaymentListFromState
                const ret = commonUtil.afterApiSuccessProcess(response, getData)
                return ret
            })
            .catch((error) => {
                // uiControll.commonErrorControl(error.response)
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH06 出金操作
    registerOrderPayment: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrderPaymentRegister.request.createRequest(params)
        const ret = await axios
            // .get(apiMock.ORDER_PAYMENT_OPERATION)
            .post(`${api.ORDER_PAYMENT_OPERATION}/${params.id}`, req)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)

                return false
            })
        return ret
    },
    // OH13 出金操作
    registerOrdersPayment: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrdersPaymentRegister.request.createRequest(params)

        const ret = await axios
            .post(api.ORDER_PAYMENT_OPERATION_LIST, req)
            .then((response) => {
                const path = mutationsTypes.ORDER_BULK_OPERATION_FLG
                commit(path, true)
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)

                return false
            })
            .finally(() => {
                const path = mutationsTypes.ORDER_BULK_OPERATION_FLG
                commit(path, false)
            })
        return ret
    },
    // OH14 一括発注完成
    registerOrdersComplete: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrdersCompleteRegister.request.createRequest(params)
        const ret = await axios
            .post(api.ORDER_COMPLETE_LIST, req)
            .then((response) => {
                const path = mutationsTypes.ORDER_BULK_OPERATION_FLG
                commit(path, true)
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
            .finally(() => {
                const path = mutationsTypes.ORDER_BULK_OPERATION_FLG
                commit(path, false)
            })
        return ret
    },
    // OH10 発注修正
    editOrder: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const req = requestOrderEdit.request.createRequest(params)
        const ret = await axios
            // .get(apiMock.ORDER_REGISTER_EDIT)
            .patch(`${api.ORDER_REGISTER_EDIT}/${params.id}`, req)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH09 出金キャンセル
    cancelOrderPayment: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        orderPaymentId
    ) => {
        await getCsrfToken()
        const ret = await axios
            // .get(apiMock.ORDER_PAYMENT_CANCEL)
            .patch(`${api.ORDER_PAYMENT_CANCEL}/${orderPaymentId}`)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH07 発注完成キャンセル
    cancelOrderComplete: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const ret = await axios
            // .get(apiMock.ORDER_COMPLETE_CANCEL)
            .patch(`${api.ORDER_COMPLETE_CANCEL}/${params.id}`)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH11 発注キャンセル
    cancelOrder: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const ret = await axios
            // .get(apiMock.ORDER_CANCEL)
            .patch(`${api.ORDER_CANCEL}/${params.id}`)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH02 発注詳細取得
    getOrderDetailListFromApi: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        const ret = await axios
            // .get(apiMock.ORDER_DETAIL_LIST)
            .get(api.ORDER_DETAIL_LIST, {params: params})
            .then((response) => {
                const path = mutationsTypes.ORDER_SET_ORDER_DETAIL_LIST
                commit(path, response.data.data)
                const getData = getters.getOrderDetailListFromState
                const ret = commonUtil.afterApiSuccessProcess(response, getData)
                return ret
            })
            .catch((error) => {
                // uiControll.commonErrorControl(error.response)
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH12 発注備考編集
    editOrderNote: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const ret = await axios
            .patch(`${api.ORDER_NOTE_EDIT}/${params.id}`, params)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH15 発注一括キャンセル
    bulkCancelOrder: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        await getCsrfToken()
        const ret = await axios
            .post(`${api.ORDER_BULK_CANCEL}`, params)
            .then((response) => {
                return response.data.errors
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return null
            })
        return ret
    },
    // SH19 販売履歴一覧CSV
    sendMailOrderCSV: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        const ret = await axios
            .get(api.ORDER_SEND_MAIL_ORDER_CSV, {params: params})
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return ret
    },
    // OH?? 発注完成
    getOrderIncompleteListFromApi: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        // TODO Need update api path after merged API
        return await axios
            .get(`${api.ORDER_INCOMPLETE_LIST}/${params.saleId}`)
            .then((response) => {
                const path = mutationsTypes.ORDER_SET_ORDER_INCOMPLETE_LIST
                const orderIncompleteList = response.data.data.notificationList
                const orderIncompleteListMapped = orderIncompleteList.map((item) => {
                    const lastname = item.user.last_name ? item.user.last_name : ''
                    const firstname = item.user.first_name ? item.user.first_name : ''
                    const fullName = lastname ? `${lastname} ${firstname}` : firstname

                    const orderReasonKey = Object.keys(
                        orderReason.ORDER_REASON_TYPE_ID
                    ).find((key) => orderReason.ORDER_REASON_TYPE_ID[key] === item.type)
                    const orderReasonLabel =
                        orderReason.ORDER_REASON_TYPE_LABEL[orderReasonKey]

                    const created_at_formatted = dateFormatYYYYMMDD(item.created_at)
                    item.user = {
                        ...item.user,
                        fullName
                    }
                    return {
                        ...item,
                        orderReason: orderReasonLabel,
                        created_at_formatted: created_at_formatted
                    }
                })
                commit(path, orderIncompleteListMapped)
                return orderIncompleteListMapped
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
    },
    registerOrderIncomplete: async (
        {state, dispatch, commit, getters, rootGetters, rootState},
        params
    ) => {
        const res = await axios
            // .get(apiMock.ORDER_COMPLETE)
            .post(`${api.ORDER_INCOMPLETE}/${params.saleId}`, params)
            .then((response) => {
                return true
            })
            .catch((error) => {
                commonUtil.afterApiFailProcess(error.response)
                return false
            })
        return res
    }
}

export default Actions
